define('controllers/blog/blogsController',[
		"application",
		"jquery",
		"angular",
		"config",
		"moment",
		"underscore",
		"toastr",
		"postaljs",
		"application",
		"directives/common/ngSquareImage"
	],
	function(app, $, angular, config, moment, _, toastr, postal) {
		"use strict";

		return app.controllers.controller("Blogs", ["$scope", "$window", function($scope, $window) {

			}
		]);
	});
